import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './shared/analytics';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})

export class AppComponent implements OnInit {
  title = 'Modernize Angular Admin Template';

  constructor(private analytics: AnalyticsService) { }

  ngOnInit(): void {
    this.analytics.init();
  }
}
